import { render, staticRenderFns } from "./T01.vue?vue&type=template&id=fc5203d2&scoped=true"
import script from "./T01.vue?vue&type=script&lang=js"
export * from "./T01.vue?vue&type=script&lang=js"
import style0 from "./T01.vue?vue&type=style&index=0&id=fc5203d2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fc5203d2",
  null
  
)

export default component.exports